import { useEffect } from "react";

const SITE = "https://feralcollective.co.uk";

const ensureMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
  return el;
};

const SeoMeta = ({ title, description, canonicalPath = "/", image = "/feral-logo-yellow.png", jsonLd }) => {
  const jsonText = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    if (title) document.title = title;

    const canonical = canonicalPath.startsWith("http") ? canonicalPath : `${SITE}${canonicalPath}`;
    const imageUrl = image.startsWith("http") ? image : `${SITE}${image}`;

    if (description) {
      ensureMeta('meta[name="description"]', { name: "description", content: description });
    }
    ensureMeta('meta[name="robots"]', { name: "robots", content: "index,follow,max-image-preview:large" });
    ensureMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    ensureMeta('meta[property="og:title"]', { property: "og:title", content: title || "FERAL Collective" });
    ensureMeta('meta[property="og:description"]', { property: "og:description", content: description || "FERAL Collective" });
    ensureMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    ensureMeta('meta[property="og:image"]', { property: "og:image", content: imageUrl });
    ensureMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    const scriptId = "feral-structured-data";
    document.getElementById(scriptId)?.remove();
    if (jsonText) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.text = jsonText;
      document.head.appendChild(script);
    }

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [title, description, canonicalPath, image, jsonText]);

  return null;
};

export default SeoMeta;
